import * as actionlist from '../actions/kpisactions';
import moment from 'moment';
const state = {
    search: '',
    page: 0,
    startdate: moment().add('days', -7).toDate(),
    enddate: new Date(),   
    activityLabelId: null
};

const getters = {
    page: state => state.page,
    search: state => state.search,
    startdate: state => state.startdate,
    enddate: state => state.enddate,
    activityLabelId: state => state.activityLabelId
};

const actions = {
    [actionlist.KPISLIST_SEARCH]: ({ commit }, search) => {
        commit(actionlist.KPISLIST_SEARCH, search);
    },
    [actionlist.KPISLIST_PAGE]: ({ commit }, page) => {
        commit(actionlist.KPISLIST_PAGE, page);
    },
    [actionlist.KPISLIST_STARTDATE]: ({ commit }, startdate) => {
        commit(actionlist.KPISLIST_STARTDATE, startdate);
    },
    [actionlist.KPISLIST_ENDDATE]: ({ commit }, enddate) => {
        commit(actionlist.KPISLIST_ENDDATE, enddate);
    },
    [actionlist.KPISLIST_ACTIVITYLABELID]: ({ commit }, activityLabelId) => {
        commit(actionlist.KPISLIST_ACTIVITYLABELID, activityLabelId);
    },
};

const mutations = {
    [actionlist.KPISLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [actionlist.KPISLIST_PAGE]: (state, page) => {
        state.page = page;
    },
    [actionlist.KPISLIST_STARTDATE]: (state, startdate) => {
        state.page = 0;
        state.startdate = startdate;
    },
    [actionlist.KPISLIST_ENDDATE]: (state, enddate) => {
        state.page = 0;
        state.enddate = enddate;
    },
    [actionlist.KPISLIST_ACTIVITYLABELID]: (state, activityLabelId) => {
        state.page = 0;
        state.activityLabelId = activityLabelId;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
